import { useSearchParams } from 'next/navigation';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useSetTransactionInformationMutation } from 'src/store/localStorage/TransactionInformationStorageApi';
import { ePages } from 'src/utilities/ePages';

export const useAccessCodeFromQueryString = () => {
  const searchParams = useSearchParams();
  const [setInfo] = useSetTransactionInformationMutation();
  const router = useRouter();
  const accessCode = searchParams?.get('accesscode');
  useEffect(() => {
    if (accessCode) {
      setInfo({ accesscode: accessCode });
      router.push(ePages.EasyPayAccessCode);
    }
  }, [accessCode, router, setInfo]);
};
